/**
 * @param {string} eventName
 * @param {string} query
 * @param {Element} delegate
 * @param {Function} cb
 */
export default (eventName, query, delegate, cb) => {
  const cbFunction = (...params) => {
    const { target } = params[0];
    if (target.matches(query) || target.closest(query)) {
      cb(...params);
    }
  };

  delegate.addEventListener(eventName, cbFunction);

  return () => {
    delegate.removeEventListener(eventName, cbFunction);
  };
};
